// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* todo: this was just copy-pasted from https://openlayers.org/en/latest/examples/popup.html.
   the popup looks ugly still, but at the very minimum the background color needs to be set to make it visible.
   the popup design needs an overhaul anyway... https://github.com/graphhopper/graphhopper-maps/issues/136
   */
.src-layers-DefaultMapPopup-module__popup {
    position: absolute;
    bottom: 12px;
    left: -50px;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 0 15px 0 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    font-size: small;
    width: 110px;
}
.src-layers-DefaultMapPopup-module__popup:after,
.src-layers-DefaultMapPopup-module__popup:before {
    top: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.src-layers-DefaultMapPopup-module__popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
}
.src-layers-DefaultMapPopup-module__popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
}
`, "",{"version":3,"sources":["webpack://./src/layers/DefaultMapPopup.module.css"],"names":[],"mappings":"AAAA;;;IAGI;AACJ;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,wCAAwC;IACxC,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;AACA;;IAEI,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB","sourcesContent":["/* todo: this was just copy-pasted from https://openlayers.org/en/latest/examples/popup.html.\n   the popup looks ugly still, but at the very minimum the background color needs to be set to make it visible.\n   the popup design needs an overhaul anyway... https://github.com/graphhopper/graphhopper-maps/issues/136\n   */\n.popup {\n    position: absolute;\n    bottom: 12px;\n    left: -50px;\n    background-color: white;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n    padding: 0 15px 0 15px;\n    border-radius: 10px;\n    border: 1px solid #cccccc;\n    font-size: small;\n    width: 110px;\n}\n.popup:after,\n.popup:before {\n    top: 100%;\n    border: solid transparent;\n    content: ' ';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n}\n.popup:after {\n    border-top-color: white;\n    border-width: 10px;\n    left: 48px;\n    margin-left: -10px;\n}\n.popup:before {\n    border-top-color: #cccccc;\n    border-width: 11px;\n    left: 48px;\n    margin-left: -11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `src-layers-DefaultMapPopup-module__popup`
};
export default ___CSS_LOADER_EXPORT___;
